import React from 'react';
import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';
import { NeighborhoodInsightChipConfig, NeighborhoodInsightChipType } from './types';


const Chip = styled(SmallText)<{ color: string; background: string }>(({ theme, color, background }) => ({
  background,
  color,
  borderRadius: theme.borderRadius.extraXLarge,
  padding: `0 ${theme.spacing(1)}`,
  fontWeight: 700,
  lineHeight: '24px',
}));

interface ChipStyleConfig {
  color: string;
  background: string;
}

const DEFAULT_NEIGHBORHOOD_INSIGHT_CHIP_UI_CONFIG: ChipStyleConfig = {
  color: '#7655f6',
  background: '#eeeafe',
};


const chipTypeToStyleConfig: Record<NeighborhoodInsightChipType, ChipStyleConfig> = {
  [NeighborhoodInsightChipType.DEALS_VOLUME]: {
    color: '#ffffff',
    background: '#43832d',
  },
  [NeighborhoodInsightChipType.POPULAR_ROOM]: {
    color: '#966643',
    background: '#f2ece8',
  },
  [NeighborhoodInsightChipType.PRICE_PER_METER]: DEFAULT_NEIGHBORHOOD_INSIGHT_CHIP_UI_CONFIG,
  [NeighborhoodInsightChipType.PRICE_TREND_COMPARED_TO_CITY]: DEFAULT_NEIGHBORHOOD_INSIGHT_CHIP_UI_CONFIG,
};

type NeighborhoodInsightChipProps = NeighborhoodInsightChipConfig;

export const NeighborhoodInsightChip: React.FC<NeighborhoodInsightChipProps> = props => {
  const { type, text } = props;
  const { color, background } = chipTypeToStyleConfig[type] || DEFAULT_NEIGHBORHOOD_INSIGHT_CHIP_UI_CONFIG;

  return (
    <Chip color={color} background={background}>
      {text}
    </Chip>
  );
};
